import axios from "axios";
import { getToken } from "../../Utils/UpdateUsersState";

// Create new user under company (company automatically assigned from backend)
const createUser = async (username, email, role, address, password) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/user/`,
      {
        name: username,
        email,
        role,
        address: address,
        password: password,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

// Edit existing user
const editUser = async (id, username, email, role, key) => {
  try {
    const res = await axios.patch(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/user/`,
      {
        user_id: id,
        name: username,
        email,
        role,
        api_key: key,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    throw e;
  }
};

// Get list of users
const getUsersList = async () => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/user/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const updatedData = res?.data?.map(user => ({
      ...user,
      profile_picture: user.profile_picture
        ? `${process.env.REACT_APP_MEDIA_URL}${user.profile_picture}`
        : null
    }));

    return { ...res, data: updatedData };
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Enable or disable user
const alterUserStatus = async (id, act) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/user-status/`,
      {
        user_id: id,
        action: act,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Login as a user
const loginAsUser = async (id) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/login-as-user/`,
      {
        user_id: id,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    const updatedProfilePicture = res?.data?.profile_picture
      ? `${process.env.REACT_APP_MEDIA_URL}${res?.data?.profile_picture}`
      : null;
    const data = { ...res.data, profile_picture: updatedProfilePicture };
    return {...res, data: data}
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Grant or restrict page access
const pageAccess = async (id, pageName, act) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/page-access/`,
      {
        user_id: id,
        page_name: pageName,
        action: act,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Reset user's password
const passwordReset = async (id, password) => {
  try {
    const res = await axios.post(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/password-reset/`,
      {
        user_id: id,
        new_password: password,
      },
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
      }
    );
    return res;
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

// Search users
const searchUser = async (q) => {
  try {
    const res = await axios.get(
      `${process.env.REACT_APP_BACKEND_URL}company-panel/search/`,
      {
        headers: {
          Authorization: `Bearer ${getToken()}`,
        },
        params: { q },
      }
    );
    const updatedData = res?.data?.map(user => ({
      ...user,
      profile_picture: user.profile_picture
        ? `${process.env.REACT_APP_MEDIA_URL}${user.profile_picture}`
        : null
    }));

    return { ...res, data: updatedData };
  } catch (e) {
    console.log(e, "error");
    return e;
  }
};

export {
  createUser,
  getUsersList,
  alterUserStatus,
  loginAsUser,
  pageAccess,
  editUser,
  searchUser,
  passwordReset,
};
